import { css, cx } from '@emotion/css';
import {
  CheckCircleOutline,
  CheckCircleSolidInverted,
} from '../../shared/assets/icons';
import { Colors } from '../../shared/styles/colors';
import { button1Style, p2Style } from '../../shared/styles/text';
import { Motion, Radius, unstyledButton } from '../../shared/styles/tokens';

interface ICurrencyAmountCardProps {
  onClick: any;
  amount: number;
  estimatedTime?: string;
  isSelected: boolean;
}

export const CurrencyAmountCard = (
  props: ICurrencyAmountCardProps,
): JSX.Element => {
  const { onClick, amount, estimatedTime, isSelected } = props;
  return isSelected ? (
    <button
      type="button"
      role="radio"
      aria-checked="true"
      className={cx(unselectedCurrencyCardStyle, selectedCurrencyCardStyle)}
      onClick={onClick}
    >
      <div>
        <span>{amount} EUR</span>
        <CheckCircleSolidInverted className={iconStyle} />
      </div>
      {estimatedTime ? <span>{estimatedTime}</span> : <></>}
    </button>
  ) : (
    <button
      type="button"
      role="radio"
      aria-checked="false"
      className={unselectedCurrencyCardStyle}
      onClick={onClick}
    >
      <div>
        <span>{amount} EUR</span>
        <CheckCircleOutline />
      </div>
      {estimatedTime ? <span>{estimatedTime}</span> : <></>}
    </button>
  );
};

export const unselectedCurrencyCardStyle = css`
  ${unstyledButton}
  width: 100%;
  border: 0.125rem solid ${Colors.CAPRI_BLUE};
  border-radius: ${Radius.md};
  background: ${Colors.WHITE};
  padding: 0.75rem 1rem;
  transition:
    background-color ${Motion.fast},
    color ${Motion.fast},
    transform ${Motion.fast},
    box-shadow ${Motion.fast};
  > div {
    ${button1Style}
    color: ${Colors.CAPRI_BLUE};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    font-variant-numeric: tabular-nums;
  }
  > div svg {
    flex: 0 0 auto;
  }
  > span {
    ${p2Style}
    color: ${Colors.TEXT_SECONDARY};
  }

  @media (hover: hover) {
    &:hover {
      background: ${Colors.CAPRI_BLUE_TINT};
    }
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: 2px solid ${Colors.CAPRI_BLUE};
    outline-offset: 2px;
  }
`;

export const selectedCurrencyCardStyle = css`
  background-color: ${Colors.CAPRI_BLUE};
  box-shadow: 0 8px 20px -10px rgba(29, 88, 131, 0.55);
  > div {
    color: ${Colors.WHITE};
  }
  > span {
    color: rgba(255, 255, 255, 0.85);
  }

  @media (hover: hover) {
    &:hover {
      background: ${Colors.CAPRI_BLUE};
    }
  }
`;

const iconStyle = css`
  fill: ${Colors.WHITE};
`;
